/**
 * Ikigai Types - v13 Section 2
 *
 * Types for the Ikigai Intelligence Layer including:
 * - 4 inference dimensions (Experiences, Relationships, Interests, Giving)
 * - 6 storage dimensions (Passion, Mission, Vocation, Profession, Relationships, Well-being)
 * - Evidence chains for transparency
 * - Well-being scoring for mission prioritization
 * - Ikigai rewards system
 *
 * @see docs/architecture/OwnYou_architecture_v13.md Section 2
 * @see docs/sprints/ownyou-sprint6-spec.md
 */
export const DEFAULT_INFERENCE_CONFIG = {
    batchWindow: 'daily',
    minItemsThreshold: 10,
    parallelInference: true,
    dataWindowDays: 90,
    modelTier: 'standard',
    // No modelOverrides by default - uses llm-client registry
    preferZDR: true, // Default to preferring ZDR models for privacy
};
export const DEFAULT_WELLBEING_CONFIG = {
    maxTotalScore: 2.0,
    boosts: {
        experienceFull: 0.5,
        experiencePartial: 0.25,
        relationshipFull: 0.5,
        relationshipGift: 0.3,
        interestDeep: 1.0,
        interestModerate: 0.7,
        interestCasual: 0.4,
        interestBase: 0.3,
        givingCharity: 0.3,
        givingGift: 0.2,
    },
};
export const DEFAULT_REWARDS_CONFIG = {
    basePoints: 100,
    multipliers: {
        experience: 2.0,
        relationship: 1.5,
        giving: 2.5,
    },
    tierThresholds: [
        { name: 'Bronze', threshold: 0 },
        { name: 'Silver', threshold: 1000 },
        { name: 'Gold', threshold: 5000 },
        { name: 'Platinum', threshold: 15000 },
        { name: 'Diamond', threshold: 50000 },
    ],
};
export const DEFAULT_REWARDS = {
    basePoints: 100,
    experienceMultiplier: 2.0,
    relationshipMultiplier: 1.5,
    givingMultiplier: 2.5,
};
export const DEFAULT_USER_POINTS = {
    total: 0,
    explorer: 0,
    connector: 0,
    helper: 0,
    achiever: 0,
};
//# sourceMappingURL=types.js.map